<template>
  <div>
    <b-loading :active="creatingOrder" />
    <div class="mx-10 my-11 pb-8 sm:mx-1">
      <div class="flex flex-col my-2">
        <w-button
          class="wrapper__go-back"
          type="text"
          @click="goBack"
        >
          <i class="icon icon-chevron-left-bold text-gray-500" />
          返回一起訂東西
        </w-button>
        <progress-bar :steps="steps" v-model="currentStepIndex" />
      </div>
      <template v-if="!loading">
        <member-selector v-if="isStepMemberSelector" />
        <order-config
          v-if="isStepOrderConfig"
          @update-draft="updateNewDraft"
        />
      </template>
    </div>
    <div
      v-if="showActionBar"
      class="wrapper__action-bar"
      :class="{ 'ml-0 sm:ml-0': isSidebarCollapsed }"
    >
      <w-button
        v-if="isLastStep"
        :disabled="loading || !canSaveDraft"
        class="mr-8"
        type="text"
        @click="saveDraft"
      >
        儲存
      </w-button>
      <w-button
        :disabled="loading || !nextStepAvailability"
        @click="onSubmit"
      >
        {{ nextStepButtonText }}
      </w-button>
    </div>
  </div>
</template>

<script>
import CreateOrder from './CreateOrder';

export default CreateOrder;
</script>

<style lang="scss" scoped>
@import 'CreateOrder';
</style>
